import React, { useState } from 'react';
import { Row, Col, Image, Space } from "antd";
import clsx from 'clsx';
import customStyles from "../../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import DropDown from "../../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../../assets/images/icon_menus/Drop Up.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import moment from 'moment';
import ImportIcon from "../../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../../assets/images/icon_actions/Export.svg";
import { useSelector } from "react-redux";
import { FilterSelect } from "../../../../../Shared/components/CustomSelect";
import FilterIcon from "../../../../../../assets/images/icon_actions/Filter Icon.svg";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import { checkComponentPermission, checkCRUDPermission, idNamingConversion } from '../../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { Link } from "react-router-dom";
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import FilterReset from "../../../../../../assets/images/icon_actions/FilterReset.svg";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import { FilterProductGroup } from "./FilterProductGroup";

export const PurchaseTopBar = (props) => {
    const { title, handleCreate, handleDatesParent,
        handleMobileFilter, productApi,
        handleStatus, topBarView, onImportVisible, handleSupplier, handleProduct, topBar, roleManagement, loadImportExportData } = props;
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const [picker, setPicker] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    // const [search, setSearch] = useState('');
    //const timeoutRef = useRef(null);
    // const prevSearch = usePrevious(search);
    // const [iconAnimation, setIconAnimation] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false)


    const handleDates = (value, reset = false) => {
        if ((value[0] !== null && value[1] !== null) || reset) {
            handleDatesParent(value);
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    // useEffect(() => {
    //     if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
    //         if (timeoutRef.current !== null) {
    //             clearTimeout(timeoutRef.current);
    //         }
    //         if (search === '') {
    //             handleSearch(search);
    //         } else {
    //             timeoutRef.current = setTimeout(() => {
    //                 timeoutRef.current = null;
    //                 handleSearch(search);
    //             }, 500);
    //         }
    //     }
    // }, [search]);

    const handlePicker = (picker) => {
        setPicker(picker);
        setStartDate(null);
        setEndDate(null);
        if (!picker) {
            handleDates([null, null], true);
        }
    }

    const mobileFilterOpen = () => {
        if (topBar?.supplierId || topBar?.productId || (topBar?.startDate && topBar?.endDate)) {
            handleMobileFilter({ status: topBar?.status });
        } else
            setFilterOpen(true);
    }

    const classes = customStyles();
    return (
        <Row className={clsx(classes.priceTopbar)}>
            {/* <Col span={4}>
                {
                    roleManagement !== '' && checkComponentPermission('Supplier Purchase Price', 'Action', 'Search') &&
                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                        <TextField autoComplete='one-time-code'
                            placeholder='Search'
                            type='search'
                            fullWidth
                            onChange={(e) => setSearch(e.target.value)}
                            className={classes.comInput}
                            variant={'standard'}
                            onFocus={() => setIconAnimation(true)}
                            onBlur={() => setIconAnimation(false)}
                        />
                        <Image
                            src={SearchIcon}
                            preview={false}
                        />
                    </div>
                }
            </Col> */}
            <Col span={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterSales)}>
                    <Space size={[20, 20]} direction="horizontal" align="center">
                        {
                            roleManagement !== '' && topBarView &&
                            (checkComponentPermission('Supplier Purchase Price', 'Action', 'Supplier Filter') ||
                                checkComponentPermission('Supplier Purchase Price', 'Action', 'Product Filter') ||
                                checkComponentPermission('Supplier Purchase Price', 'Action', 'Date Filter')) && <>
                                <NavLink
                                    to="#"
                                    id={idNamingConversion('Filter', 'purchasePrice', 'Link')}
                                    className={clsx(classes.customLink, classes.customFilter)}
                                    onClick={() => mobileFilterOpen()}>
                                    {
                                        topBar?.supplierId || topBar?.productId || (topBar?.startDate && topBar?.endDate) ?
                                            <>
                                                <Image
                                                    src={FilterReset}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Reset Filter</span>
                                            </>
                                            : <>
                                                <Image
                                                    src={FilterIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Filter</span>
                                            </>
                                    }
                                </NavLink></>
                        }

                        {
                            roleManagement !== '' && topBarView && checkComponentPermission('Supplier Purchase Price', 'Action', 'Supplier Filter') &&
                            <AutoCompleteComponent
                                customLabel={"All Suppliers"}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={supplierDetails}
                                id={idNamingConversion('All Suppliers', 'purchasePrice', 'DropDown')}
                                customClasses={clsx(classes.customWidth172P, classes.customFilterNone)}
                                parentValue={customObject(supplierDetails, topBar?.supplierId)}
                                position={"bottom"}
                                variant={'outlined'}
                                onChangeText={(data) => {
                                    if (data === '') {
                                        handleSupplier('')
                                    }
                                }}
                                onChange={(data) => {
                                    handleSupplier(data.id);
                                }}
                            />
                        }
                        {
                            roleManagement !== '' && checkComponentPermission('Supplier Purchase Price', 'Action', 'Product Filter') &&
                            <AutoCompleteComponent
                                customLabel={"All Product"}
                                heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                { 'key': 'productId', 'name': 'Product ID' },
                                { 'key': 'code', 'name': 'Product Code' }]}
                                details={myProductdetails}
                                id={idNamingConversion('All Product', 'purchasePrice', 'DropDown')}
                                parentValue={customObject(myProductdetails, topBar?.productId)}
                                position={"bottom"}
                                customClasses={clsx(classes.customWidth172P, classes.customFilterNone)}
                                variant={'outlined'}
                                onChangeText={(data) => {
                                    if (data === '') {
                                        handleProduct('')
                                    }
                                }}
                                searchType={(s) => productApi(s)}
                                onChange={(data) => {
                                    handleProduct(data.id)
                                }}
                            />
                        }
                        {
                            roleManagement !== '' && checkComponentPermission('Supplier Purchase Price', 'Action', 'Date Filter') &&
                            <div className={clsx(classes.dateFilterwidth, classes.width250, classes.customFilterNone)}>
                                <Row>
                                    <Col span={24}>
                                        <NavLink
                                            id={idNamingConversion('Date Filter', 'purchasePrice', 'Link')}
                                            to={'#'} onClick={() => handlePicker(!picker)}
                                            className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                            Date Filter <Image
                                                src={picker ? DropUp : DropDown}
                                                preview={false} />
                                        </NavLink>
                                    </Col>
                                    {
                                        picker && <Col span={24}>
                                            <div className={clsx(classes.dateFilterdateAdjust)}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        fullWidth
                                                        slots={{
                                                            openPickerIcon: DateIcon
                                                        }}
                                                        views={['year', 'month', 'day']}
                                                        allowKeyboardControl={false}
                                                        value={startDate}
                                                        label="From Date"
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,

                                                            },
                                                            //inputProps: { value: moment(startDate).format('DD/MM/YYYY'), readOnly: false }
                                                        }}
                                                        format="dd/MM/yyyy"
                                                        onChange={(newValue) => {
                                                            handleDates([moment(newValue).format("YYYY-MM-DD"), endDate]);
                                                            setStartDate(newValue);
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                id: idNamingConversion('From Date', 'purchasePrice', 'TextField'),
                                                                autoComplete: 'one-time-code'
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        fullWidth
                                                        slots={{
                                                            openPickerIcon: DateIcon
                                                        }}
                                                        views={['year', 'month', 'day']}
                                                        allowKeyboardControl={false}
                                                        value={endDate}
                                                        minDate={new Date(startDate)}
                                                        label="To Date"
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor
                                                            },
                                                            //inputProps: { value: moment(endDate).format('DD/MM/YYYY'), readOnly: false }
                                                        }}
                                                        format="dd/MM/yyyy"
                                                        onChange={(newValue) => {
                                                            handleDates([startDate, moment(newValue).format("YYYY-MM-DD")]);
                                                            setEndDate(newValue);
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                id: idNamingConversion('To Date', 'purchasePrice', 'TextField'),
                                                                autoComplete: 'one-time-code'
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        }
                        {
                            roleManagement !== '' && topBarView && checkComponentPermission('Supplier Purchase Price', 'Action', 'Status Filter') &&
                            <FilterSelect
                                parentClasses={clsx(classes.dateFilterwidth, classes.width125)}
                                customClasses={clsx(classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}
                                details={[{ slug: "", label: "All" }, { slug: "active", label: "Active" }, { slug: "inactive", label: "In-active" }]}
                                onChange={(e) => { handleStatus(e.target.value) }}
                                defaultValue={topBar?.status}
                                heads={['slug', 'label']}
                                id={idNamingConversion('All', 'purchasePrice', 'DropDown')}
                            />
                        }
                        {
                            roleManagement !== '' && topBarView && checkComponentPermission('Supplier Purchase Price', 'Action', 'Export') &&
                            <NavLink
                                to="#"
                                id={idNamingConversion('Export', 'purchasePrice', 'Link')}
                                onClick={() => loadImportExportData('Supplier Purchase Price')}
                                className={clsx(classes.customLink)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                            </NavLink>
                        }
                        {
                            roleManagement !== '' && topBarView && checkComponentPermission('Supplier Purchase Price', 'Action', 'Import') &&
                            <NavLink
                                to="#"
                                id={idNamingConversion('Import', 'purchasePrice', 'Link')}
                                onClick={() => onImportVisible(true)}
                                className={clsx(classes.customLink)}>
                                <Image
                                    src={ImportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                            </NavLink>
                        }
                        {
                            !topBarView &&
                            <Link id={idNamingConversion('View All Prices', 'purchasePrice', 'Link')} to={`/purchase/setup/purchase-price`} className={clsx(classes.color, classes.bold)}>
                                <Image src={ViewIcon} preview={false} /> <span>View All Prices</span>
                            </Link>
                        }
                        {
                            roleManagement !== '' && topBarView && checkCRUDPermission('Supplier Purchase Price', 'create', 'Purchase') &&
                            <NavLink
                                to="#"
                                id={idNamingConversion('Create', 'purchasePrice', 'Link')}
                                onClick={() => handleCreate()}
                                className={clsx(classes.customLink)}>
                                <Image
                                    src={AddIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.textCapital)}>Create {title}</span>
                            </NavLink>
                        }
                        <></>
                    </Space>
                </div>
            </Col>
            <PrimaryDrawer
                open={filterOpen}
                title={'Filter and Product Group'}
                width={"360px"}
                handleClose={() => setFilterOpen(false)}
                className={clsx(classes.closeBackGround, classes.width100MaintainPrice)}
                component={
                    <FilterProductGroup
                        myProductdetails={myProductdetails}
                        supplierDetails={supplierDetails}
                        handleCloseMobile={() => setFilterOpen(false)}
                        customObject={(details, id) => customObject(details, id)}
                        handleMobileFilter={(data) => { setFilterOpen(false); handleMobileFilter(data) }}
                        roleManagement={roleManagement}
                        topBarView={topBarView}
                        topBar={topBar}
                    />
                }
            />
        </Row>
    )
};